import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=3aa3eb2a&scoped=true&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"
import style0 from "./EditNote.vue?vue&type=style&index=0&id=3aa3eb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3eb2a",
  null
  
)

export default component.exports